import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import {
    Box,
    Checkbox,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import { DataGridPro, LicenseInfo } from '@mui/x-data-grid-pro';
import {
    CameraAlt,
    Check,
    Undo,
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';

import BaseCheckbox from '../checkbox/BaseCheckbox';



LicenseInfo.setLicenseKey('17ca2e8476fa658618680f9f135dbc81T1JERVI6MzU2MTYsRVhQSVJZPTE4NzMzODQyMDIwMDAsS0VZVkVSU0lPTj0x',);

const CustomTable = styled(Table)({
    // backgroundColor: 'rgb(28, 28, 28)',
    borderRadius: 4,
});

const CustomTableHead = styled(TableHead)({
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
});

const CustomTableCell = styled(TableCell)({
    color: 'rgb(255, 255, 255)',
    fontWeight: 700,
    borderColor: 'rgba(139, 142, 146, 0.5)',
    fontSize: '13px',
});





function MetadataSourceSettings({ settings = {}, setSettings = () => {} }) {

    const columns = [
        { field: 'source', headerName: 'Source', renderCell: (params) => (
            <Box
                display="flex"
                flexDirection="column"
                m={1}
                position='relative'
            >
                {
                    settings?.[params.value] !== params.row.enabled && (
                        <Box
                            position="absolute"
                            top={0}
                            left={0}
                            mx={-1}
                            my={0.8}
                        >
                        <Box
                            width={5}
                            height={5}
                            borderRadius={5}
                            backgroundColor={'rgba(255, 193, 7, 1)'} // warning color (amber)
                        />
                    </Box>
                )}
                <Typography
                    variant="subtitle2"
                    fontWeight={900}
                    fontSize="12px"
                >
                    {params.value}
                </Typography>
            </Box>
        )},
        { field: 'enabled', headerName: 'Enabled', renderCell: (params) => (
            <BaseCheckbox
                checked={params.value}
                onChange={(event) => handleChange(params.row.source, event.target.checked)}
            />
        ), width: 100 },
    ];
    const [rows, setRows] = useState([]);
    const [sourceSettings, setSourceSettings] = useState(settings);

    useEffect(() => {
        setSourceSettings(settings)
    }, [settings])

    useEffect(() => {
        setRows(
            Object.entries(sourceSettings).map(([source, enabled]) => {
                return {
                    id: source,
                    source: source,
                    enabled: enabled,
                };
            })
        );
    }, [sourceSettings]);

    function handleChange(field, value) {
        const updatedSettings = _.cloneDeep(sourceSettings);
        updatedSettings[field] = value;
        updateSettings(updatedSettings);
    }

    function handleDiscard() {
        setSourceSettings(settings);
    }

    function updateSettings(newSettings) {
        setSourceSettings(newSettings);
        setSettings(newSettings);
    }

    return (
        <Box
            display="flex"
            border={'1px solid rgba(139, 142, 146, 1)'}
            borderRadius={4}
            position="relative"
            width='100%'
        >
            {
                !_.isEqual(settings, sourceSettings) && 
                <Box
                    position="absolute"
                    top={0}
                    right={0}
                    p={1}
                >
                    <IconButton
                        sx={{
                            color: 'rgba(180, 120, 120, 0.7)', // muted red
                            transition: 'color 0.2s',
                            '&:hover': {
                                color: 'rgb(211, 47, 47)', // vivid red
                            },
                        }}
                        onClick={handleDiscard}
                    >
                        <Undo
                            sx={{
                                fontSize: '16px',
                            }}
                        />
                    </IconButton>
                    <IconButton
                        sx={{
                            color: 'rgba(120, 180, 120, 0.7)', // muted green
                            fontSize: '16px',
                            transition: 'color 0.2s',
                            '&:hover': {
                                color: 'rgb(46, 225, 50)', // vivid green
                            },
                        }}
                    >
                        <Check
                            sx={{
                                fontSize: '16px',
                            }}
                        />
                    </IconButton>
                </Box>
            }
            <Box
                m={2}
                display="flex"
                flexDirection="column"
                gap={2}
                overflow='auto'
            >
                <Typography variant="h6">
                    Metadata Source Settings
                </Typography>
                <Box
                    maxHeight='100%'
                    maxWidth='100%'
                >
                    <DataGridPro
                        sx={{
                            backgroundColor: '#101010',
                            borderColor: '#122218',
                            '& .MuiDataGrid-root': { cursor: 'pointer' },
                            '& .MuiDataGrid-cell:hover': { color: 'rgb(76, 146, 107)' },
                            '& .MuiDataGrid-columnSeparator': {
                                borderColor: 'green',
                                borderWidth: '2px',
                                visibility: 'visible',
                                '&:hover': { borderColor: 'rgb(76, 146, 107)' },
                            },
                            '& .MuiDataGrid-columnHeaders': { backgroundColor: '#101010' },
                            '& .MuiDataGrid-columnHeader': {
                                fontSize: 14,
                                color: 'white',
                                fontWeight: 'bold',
                                borderBottom: 'None',
                            },
                            '& .MuiDataGrid-row': { border: 'none' },
                            '& .MuiDataGrid-rowCount, & .MuiDataGrid-selectedRowCount': { color: 'white' },
                            '& .MuiDataGrid-cell': {
                                border: 'none',
                                color: 'white',
                                fontSize: 13,
                            },
                            '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: '#161618' },
                            '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: '#202020' },
                            '& .MuiDataGrid-row:hover': { backgroundColor: 'rgba(76, 146, 107, 0.1)' },
                            '& .MuiDataGrid-pinnedColumnHeaders, & .MuiDataGrid-pinnedColumns': { backgroundColor: '#101010' },
                            '& .MuiDataGrid-pinnedColumns .MuiDataGrid-cell': {
                                backgroundColor: 'inherit',
                                color: 'white',
                                fontSize: 13,
                                border: 'none',
                            },
                            '& .MuiDataGrid-pinnedColumns .MuiDataGrid-row:nth-of-type(odd) .MuiDataGrid-cell': { backgroundColor: '#161618' },
                            '& .MuiDataGrid-pinnedColumns .MuiDataGrid-row:nth-of-type(even) .MuiDataGrid-cell': { backgroundColor: '#202020' },
                            '& .MuiDataGrid-pinnedColumns .MuiDataGrid-row:hover .MuiDataGrid-cell': { backgroundColor: 'rgba(76, 146, 107, 0.1)' },
                            // Remove all row styles if disabled-row
                            '& .MuiDataGrid-row.disabled-row': {
                                backgroundColor: 'inherit !important',
                                color: 'grey !important',
                            },
                            '& .MuiDataGrid-row.disabled-row .MuiDataGrid-cell': {
                                backgroundColor: 'inherit !important',
                                color: 'grey !important',
                                fontSize: 13,
                                border: 'none',
                            },
                            '& .MuiDataGrid-row.disabled-row:hover': {
                                backgroundColor: 'inherit !important',
                            },
                            // Add flag row style if duplicate-row
                            '& .MuiDataGrid-row.duplicate-row': {
                                backgroundColor: 'rgba(200, 0, 0, 0.1) !important',
                                color: 'grey !important',
                            },
                            '& .MuiDataGrid-row.duplicate-row .MuiDataGrid-cell': {
                                backgroundColor: 'rgba(200, 0, 0, 0.1) !important',
                                color: 'grey !important',
                                fontSize: 13,
                                border: 'none',
                            },
                            '& .MuiDataGrid-row.duplicate-row:hover': {
                                backgroundColor: 'rgba(200, 0, 0, 0.1) !important',
                            },
                        }}
                        columns={columns}
                        rows={rows}
                        hideFooter
                        autoHeight
                    />
                </Box>
            </Box>
        </Box>
    );
}

export default MetadataSourceSettings;